import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Paper from "@mui/material/Paper";
import classes from "../../styles/DashboardView.module.css";
import { MonthCountCompare } from "../../utilities/dashboardAggregations";
import { YoYLegend, lightenMetricColor } from "./YoYLegend";
import { IndexBadge } from "./IndexBadge";

interface RegistrationsChartProps {
    data: MonthCountCompare[];
    currentYearLabel: string;
    prevYearLabel: string;
}

const COLOR = "#1976d2";
const PREV_COLOR = lightenMetricColor(COLOR);

export function RegistrationsChart({ data, currentYearLabel, prevYearLabel }: RegistrationsChartProps) {
    if (!data || data.length === 0) {
        return (
            <Paper className={classes.chartCard} elevation={2}>
                <div className={classes.chartTitle}>Tilmeldinger pr. måned</div>
                <p>Ingen data</p>
            </Paper>
        );
    }

    return (
        <Paper className={classes.chartCard} elevation={2}>
            <div className={classes.chartHeader}>
                <h3 className={classes.chartTitle}>Tilmeldinger pr. måned</h3>
                <YoYLegend currentColor={COLOR} prevColor={PREV_COLOR} currentYearLabel={currentYearLabel} prevYearLabel={prevYearLabel} />
            </div>
            <ResponsiveContainer width="100%" height={320}>
                <BarChart data={data} barCategoryGap="18%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                    <XAxis dataKey="month" tick={{ fontSize: 12 }} />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip content={({ active, payload }: any) => {
                        if (!active || !payload || !payload[0]) return null;
                        const d: MonthCountCompare = payload[0].payload;
                        return (
                            <div style={{ background: "white", border: "1px solid #ccc", padding: 10, borderRadius: 4, minWidth: 180 }}>
                                <div style={{ fontWeight: 600, marginBottom: 6, textTransform: "capitalize" }}>{d.month}</div>
                                <div style={{ fontSize: 13, color: COLOR, fontWeight: 600 }}>{currentYearLabel}: {d.current} tilmeldinger</div>
                                <div style={{ fontSize: 12, color: PREV_COLOR, fontWeight: 600 }}>{prevYearLabel}: {d.previous} tilmeldinger</div>
                                <IndexBadge current={d.current} previous={d.previous} />
                            </div>
                        );
                    }} />
                    <Bar dataKey="previous" fill={PREV_COLOR} radius={[3, 3, 0, 0]} />
                    <Bar dataKey="current" fill={COLOR} radius={[3, 3, 0, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
}
